import { render, staticRenderFns } from "./step-header.vue?vue&type=template&id=0f38dd54&scoped=true&"
import script from "./step-header.vue?vue&type=script&lang=js&"
export * from "./step-header.vue?vue&type=script&lang=js&"
import style0 from "./step-header.vue?vue&type=style&index=0&id=0f38dd54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38dd54",
  null
  
)

component.options.__file = "step-header.vue"
export default component.exports